<template>
  <div class="view-machine-repairs pad">

    <div class="pad-bottom">
      <back-button />
    </div>

    <template v-if="machine === null">
      <loading />
    </template>

    <template v-else-if="machine">
      <h1 class="title is-3">{{ machine.name }}</h1>
      <repairs :machine="machine" :show-fixed="true" />
    </template>

    <b-message type="is-danger" v-if="errArr.length">
      <p v-for="(msg, i) in errArr" :key="i">{{ msg }}</p>
    </b-message>

  </div>
</template>

<script>
import Repairs from '@/components/Repairs'
export default {
  name: 'ViewMachineRepairs',
  components: {
    Repairs
  },
  data () {
    return {
      machine: null,
      machineId: null,
      errArr: []
    }
  },
  computed: {
    serviceDue () { return this.machine && this.machine.smu > this.machine.nextService }
  },
  watch: {
    machineId () {
      this.unsub('machines')
      this.subs.machines = this.$firestore.collection('machines')
        .doc(this.machineId)
        .onSnapshot(snapshot => {
          this.machine = this.$utils.snapshotToObj(snapshot)
        })
    }
  },
  beforeRouteUpdate (to, from, next) {
    this.machineId = to.params.id
    next()
  },
  created () {
    this.machineId = this.$route.params.id
  }
}
</script>

<style>

</style>
